import React from "react";
import PropTypes from "prop-types";
import Row from "../../common/Row";

const TotaalAantalBezoekers = (props) => {
	const {
		bereikDoelgroepen,
		isInTheFuture,
		indexes
	} = props;

	let totalen = {};
	indexes.forEach(index => {
		totalen["totaalJaar" + index] = 0;
	});

	bereikDoelgroepen.forEach(element => {
		indexes.forEach(index => totalen["totaalJaar" + index] += Number(element["aantalBezoekersJaar" + index]));
	});

	return (
		<Row>
			<b>
				<label className={"o-col-5"} style={{ textAlign: 'right' }}>
					Totalen per jaar voor de {isInTheFuture ? "komende" : "vorige"} 5 jaar
				</label>
				{
					indexes.map(index =>
						(<label key={index} className={"o-col-1"} style={{ textAlign: 'center' }}>
							{totalen["totaalJaar" + index]}
						</label>))
				}
			</b>
		</Row>);
};

// ----------------------------------------------------------------------------
TotaalAantalBezoekers.propTypes = {
	bereikDoelgroepen: PropTypes.arrayOf(PropTypes.object),
	isInTheFuture: PropTypes.bool.isRequired,
	indexes: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default TotaalAantalBezoekers;